import { motion, AnimatePresence } from 'framer-motion';
import { X, Shield } from 'lucide-react';

interface CadresReferentielsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CadresReferentielsModal({ isOpen, onClose }: CadresReferentielsModalProps) {
  if (!isOpen) return null;
  const cadres = [
    { layer: "Gouvernance IA (Entreprise)", standard: "ISO/IEC 42001", note: "Politique, objectifs, rôles, risques IA" },
    { layer: "Risque IA (Produit)", standard: "NIST AI RMF 1.0", note: "Identifier/mesurer/atténuer/surveiller" },
    { layer: "SDLC Sécurisé", standard: "NIST SSDF + OWASP SAMM", note: "Sécurité by design, supply-chain" },
    { layer: "Qualité Produit", standard: "ISO/IEC 25010", note: "Performance, fiabilité, maintenabilité, UX" },
  ];
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-violet-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-violet-500/30 shadow-2xl shadow-violet-500/20"
          >
            <div className="relative p-8 border-b border-violet-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-violet-500 to-purple-500 rounded-xl">
                    <Shield className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-purple-400">
                      Cadres Référentiels
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Standards internationaux pour qualité, sécurité et conformité</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-violet-600/20 via-purple-600/20 to-violet-600/20 rounded-xl p-8 border-2 border-violet-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">Nos Standards</h3>
                <p className="text-gray-300 text-center text-lg">
                  Nous suivons les standards internationaux pour garantir qualité, sécurité et conformité.
                </p>
              </div>
              <div className="space-y-4">
                {cadres.map((c, idx) => (
                  <div key={idx} className="bg-gradient-to-br from-violet-500/10 to-purple-500/10 rounded-xl p-6 border border-violet-500/30">
                    <h4 className="text-xl font-bold text-white mb-2">{c.layer}</h4>
                    <p className="text-violet-400 font-semibold mb-2">{c.standard}</p>
                    <p className="text-gray-300 text-sm">{c.note}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="p-6 border-t border-violet-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-violet-500 to-purple-500 text-white rounded-xl hover:from-violet-600 hover:to-purple-600 transition-all duration-200 font-semibold shadow-lg shadow-violet-500/20 hover:shadow-violet-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

